import httpApiApplication from '../../../http/httpApiApplication';

import { type FormStatement } from './types';

export const baseUrl = '/FormStatement';

export function updateFormStatement(id: string, request: FormStatement) {
  return httpApiApplication.put(`${baseUrl}/${id}`, request);
}

export function deleteFormStatement(id: string) {
  return httpApiApplication.delete(`${baseUrl}/${id}`);
}

export const createFormStatement = (request: FormStatement) => {
  return httpApiApplication.post(baseUrl, request);
};
